// extracted by mini-css-extract-plugin
export default {"container":"CategoryHeader_container__yaUPf","arrow":"CategoryHeader_arrow__Mk5jS"};